import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type GroupIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const GroupIcon: React.FC<GroupIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group">
        <path id="Union" fillRule="evenodd" clipRule="evenodd" d="M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 5C8.55228 5 9 4.55228 9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4C7 4.55228 7.44772 5 8 5ZM8.5 7C8.5 6.72386 8.27614 6.5 8 6.5C7.72386 6.5 7.5 6.72386 7.5 7V12.5C7.5 12.7761 7.72386 13 8 13C8.27614 13 8.5 12.7761 8.5 12.5V7Z" fill={color} />
      </g>
    </svg>
  </IconSpan>
);
